<app-entity-onboard [content]="content" (formValues)="setFormValues($event)" (onDialogClose)="closeDialog()"></app-entity-onboard>